const white = "#FFFFFF";
const black = "#000000";
const ericsson = "#002561";

export default {
  black,
  white,
  ericsson,
  text: {
    primary: "#CCCEDA",
    secondary: white,
    tertiary: "#535354",
    active: "#47c431",
  },
  background: {
    primary: "#0a0a0c",
    secondary: "#212121",
    header: "#424242",
    footer: "#303030",
  },
  action: {
    selected: "#4F5974",
    hover: "#444444",
    disabled: "#9B9B9B",
  },
  tableCellDivider: "#12131F",
  icon: "#CCCEDA",
  chip: "#10121A",
};
